import { get } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SelectionAssigned from './SelectionAssigned';
import SelectionNotAssigned from './SelectionNotAssigned';
import * as Styled from './styles';
import SuccessfullyEntered from './SuccessfullyEntered';
import EventStarted from './EventStarted';
import Terms from '../Terms';
import { getDayOfWeek, getFormattedTime } from '../../helpers/dateTimeHelpers';

const Entered = ({
    title,
    eventName,
    prize,
    hasEventStarted,
    entry,
    excludeFromBetting,
    startDate,
    TermsLink,
    bettingEnabled
}) => {
    const clothNumber = get(entry.metaData, 'clothNumber', null);
    const name = get(entry, 'name', null);
    const metaData = get(entry, 'metaData', {});
    const jockeyName = get(metaData, 'jockeyName', null);
    const trainerName = get(metaData, 'trainerName', null);
    const silk = get(metaData, 'silk', null);
    const excludeBetting = hasEventStarted || excludeFromBetting;
    const hasEventNotStarted = !hasEventStarted;

    const weekday = startDate ? getDayOfWeek(startDate) : null;
    const time = startDate ? getFormattedTime(startDate) : null;

    return (
        <>
            <Styled.EnteredWrapper>
                <Styled.EnteredContentWrapper>
                    <Styled.Title>{title} SWEEPSTAKE</Styled.Title>
                    {hasEventStarted ? (
                        <EventStarted eventName={eventName} />
                    ) : (
                        <SuccessfullyEntered title={title} />
                    )}
                    {name ? (
                        <>
                            <SelectionAssigned
                                title={title}
                                clothNumber={clothNumber}
                                horseName={name}
                                jockeyName={jockeyName}
                                trainerName={trainerName}
                                silk={silk}
                                excludeFromBetting={excludeBetting}
                                bettingEnabled={bettingEnabled}
                            />
                        </>
                    ) : (
                        <SelectionNotAssigned raceName={eventName} />
                    )}
                    {name && hasEventStarted && (
                        <Terms
                            showTermsText={false}
                            margin="16px 0 0 0"
                            TermsLink={TermsLink}
                        />
                    )}
                    {hasEventNotStarted && (
                        <>
                            <Styled.PrizeText>
                                If your horse wins the{' '}
                                <Styled.Highlighted>
                                    {time} {eventName} race
                                </Styled.Highlighted>{' '}
                                {weekday ? `on ${weekday}` : ''}, you will be
                                entered into a Prize Draw to win{' '}
                                <Styled.Highlighted>
                                    {prize}!
                                </Styled.Highlighted>
                            </Styled.PrizeText>
                            <Terms
                                margin="0"
                                startDate={startDate}
                                TermsLink={TermsLink}
                            />
                        </>
                    )}
                </Styled.EnteredContentWrapper>
            </Styled.EnteredWrapper>
        </>
    );
};

Entered.defaultProps = {
    startDate: undefined,
    entry: {}
};

Entered.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired,
    hasEventStarted: PropTypes.bool.isRequired,
    entry: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        metaData: PropTypes.shape({
            clothNumber: PropTypes.string,
            jockeyName: PropTypes.string,
            trainerName: PropTypes.string,
            silk: PropTypes.string
        })
    }),
    excludeFromBetting: PropTypes.bool.isRequired,
    startDate: PropTypes.string,
    TermsLink: PropTypes.func.isRequired,
    bettingEnabled: PropTypes.bool.isRequired
};

export default Entered;
